import { decodeBase64, encodeBase64 } from "./base64";

/**
 * SearchAnalyticsView ID から Project ID を復元します。
 * ID 形式: SearchAnalyticsView:customers/{org}/projects/{project}/...
 */
export function toProjectIdFromSaViewId(viewId: string): string | null {
  try {
    const decoded = decodeBase64(viewId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    if (!orgDb || !projectDb) return null;
    const rawProject = `Project:customers/${orgDb}/projects/${projectDb}`;
    return encodeBase64(rawProject);
  } catch {
    return null;
  }
}
